import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Downward.svg",
  "use": "Downward.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Downward.svg\"><path d=\"M25.022,12V31.9889H17.018a2.0031,2.0031,0,0,0-1.536,3.2852L30.4806,53.3009a1.9975,1.9975,0,0,0,3.0722,0L48.5512,35.2741a2.0033,2.0033,0,0,0-1.5364-3.2852H39.0091V12a1.9991,1.9991,0,0,0-1.9982-2H27.02A1.9992,1.9992,0,0,0,25.022,12Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol